/**
 * Ops Page Route Self-Check API Contract (SCH-2975)
 *
 * GET /internal/infrastructure/ops-page-routes
 *
 * Read-only. Asks Slack, as the backend's bot, whether each ops page route can
 * be posted to: the channel resolves and the bot is a member. `unverifiable`
 * means the check itself got no answer (a missing scope, no token, an API
 * error); it is never read as `ok`.
 */

import { z } from 'zod'

export const OPS_PAGE_ROUTE_STATUSES = ['ok', 'not_member', 'not_found', 'unverifiable'] as const

export const OpsPageRouteCheckSchema = z.object({
  /** The ops page kind, e.g. `school_down`. */
  kind: z.string(),
  /** The Slack channel id the kind routes to. */
  channelId: z.string(),
  status: z.enum(OPS_PAGE_ROUTE_STATUSES),
  /** Slack's error code, or `is_archived`; null when the route is ok or the bot is simply not a member. */
  detail: z.string().nullable()
})

export const GetOpsPageRoutesResponseSchema = z.object({
  checkedAt: z.string(),
  /** True only when every route is `ok`. */
  healthy: z.boolean(),
  routes: z.array(OpsPageRouteCheckSchema)
})

export type GetOpsPageRoutesResponse = z.infer<typeof GetOpsPageRoutesResponseSchema>
